import { MissingTextState, CompileState, REJECT, RESOLVE } from './state.js';
import { nameFor } from './utils.js';

const CACHE = new Map();
function compile(service, text, options) {
  const data = {
    format: options.format
  };
  if (!text) {
    return new MissingTextState(data);
  }
  const id = nameFor(`${options.format}:${text}`);
  const state = new CompileState(data);

  // Fills the cache as well
  runTheCompiler({
    service,
    text,
    options,
    state,
    id
  });
  return state;
}
async function runTheCompiler({
  service,
  text,
  options,
  state,
  id
}) {
  await options?.onCompileStart?.();
  await Promise.resolve();
  if (!text) {
    state[REJECT](new Error('No Input Document yet'));
    await options?.onError?.('No Input Document yet');
    return;
  }
  let result;

  // TODO: just use compile, eliminate all this branching
  if (options.format === 'glimdown') {
    result = await service.compile('gmd', text, options);
  } else if (options.format === 'gjs') {
    result = await service.compileGJS(text, options);
  } else if (options.format === 'hbs') {
    result = await service.compileHBS(text, options);
  } else {
    result = await service.compile(options.format, text, options);
  }
  if (result.error) {
    state[REJECT](result.error);
    await options?.onError?.(state.reason || 'Unknown Error');
    return;
  }
  CACHE.set(id, result.component);
  state[RESOLVE](result.component);
  await options?.onSuccess?.(result.component);
}

export { CACHE, compile };
//# sourceMappingURL=compile.js.map
